export default __webpack_public_path__ + "static/media/Entourage_R2.ea7fff40.png";